import { render, staticRenderFns } from "./sup-tasks.vue?vue&type=template&id=c113185a&scoped=true&"
import script from "./sup-tasks.vue?vue&type=script&lang=js&"
export * from "./sup-tasks.vue?vue&type=script&lang=js&"
import style0 from "./sup-tasks.css?vue&type=style&index=0&id=c113185a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c113185a",
  null
  
)

export default component.exports